import React, {useEffect, useState} from "react";
import AutoFormCard from "../../../components/common/AutoFormCard";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ApiService} from "../../../services/ApiService";
import {message} from "antd";
import {FormUtils} from "../../../utils/FormUtils";

const FORM = [
    {
        name: "属性名",
        key: "name",
        type: "select",
    },
    {
        name: "属性值",
        key: "value",
        type: "input",
    },
]

const SystemPropertyEditPage = () => {
    const [searchParams] = useSearchParams()
    const navigator = useNavigate()

    const name = searchParams.get("name")

    const [initFormData, setInitFormData] = useState({})
    const [names, setNames] = useState([])

    let changedForms = {}
    let changedFiles = {}

    useEffect(() => {
        if (name) {
            ApiService.admin.system.properties.get(name)
                .onSuccess(data => {
                    setInitFormData(data)
                })
        }

        ApiService.admin.system.properties.names()
            .onSuccess(data => {
                setNames(data)
            })
    }, [name]);

    const handleFormChange = (change) => {
        changedForms = {
            ...changedForms,
            ...change
        }
    }

    const handleFileChange = (change) => {
        changedFiles = {
            ...changedFiles,
            ...change
        }
    }

    const createOrUpdate = (form) => {
        return ApiService.admin.system.properties.createOrUpdate(form)
    }

    const handleFormSubmit = (event) => {
        try {
            const form = FormUtils.setupSubmitForm(changedForms, changedFiles, true, false)
            // 因为API的更新和新建合并在一起了，需要初始化表单来补充没有变更的数据
            const submitData = {
                ...initFormData,
                ...form
            }
            createOrUpdate(submitData)
                .onSuccess(() => {
                    message.success("数据已保存")
                    navigator(-1)
                })
        } catch (e) {
            message.error(e.message)
            return false
        }
    }

    return (
        <>
            <AutoFormCard
                title={"编辑系统属性"}
                formStruct={FORM}
                initValues={initFormData}
                selectOptions={{
                    name: names
                }}
                loading={false}
                onClickCancel={e => {
                    navigator(-1)
                }}
                onClickSubmit={handleFormSubmit}
                onFormChange={handleFormChange}
                onFileChange={handleFileChange}
            />
        </>
    )
}

export default SystemPropertyEditPage